import { DECISIONS_STORY } from "./fixture-decisions-run";
import type { ShotStory } from "./story";
import { ShotStoryTurn } from "./turn";
import { ShotAnswerFooter, ShotClosedTrace, ShotWindow } from "./window";

/**
 * The sample workspace's finished session at rest: the home's decisions
 * question answered, unless a page brings its own story. Without the
 * composer, so the answer's table has the room a first screen gives it, and
 * without a figure's label and caption: the frame is decoration beside words
 * that already say what it shows. The wrapper is the scope the shots'
 * stylesheet applies within (product-shot.css).
 */
export function AnsweredFrame({ heightClass, story = DECISIONS_STORY }: { heightClass: string; story?: ShotStory }) {
  return (
    <div data-shot-scope="">
      <ShotWindow
        tone="light"
        workspace={story.workspace}
        aria-hidden="true"
        inert
        heightClass={heightClass}
        composer={null}
        transcript={<ShotStoryTurn story={story} />}
        footer={
          <ShotAnswerFooter
            trace={<ShotClosedTrace label={story.trace.label} durationLabel={story.trace.durationLabel} />}
          />
        }
      />
    </div>
  );
}
